import { FC } from 'react';

export const BaseLayout: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      {children}
    </div>
  );
};

export default BaseLayout;
